export default __webpack_public_path__ + "static/media/avatar_dog6.02061246.mp3";